(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('MonitoringRuleHistoryController', MonitoringRuleHistoryController);

    MonitoringRuleHistoryController.$inject = ['$scope', '$filter', '$timeout', '$window', '$uibModal', 'AlertService', 'Agence',
        'MonitoringRule', 'MonitoringRuleErrorHistory', 'Principal'];

    function MonitoringRuleHistoryController($scope, $filter, $timeout, $window, $uibModal, AlertService, Agence, MonitoringRule,
        MonitoringRuleErrorHistory, Principal) {
        var vm = this;
        var processedUpdates = {};
        var currentAccount = null;
        var listRevision = 0;
        var destroyed = false;

        vm.filters = {
            processedStatus: 'all',
            viewMode: 'summary',
            errorItemText: null,
            recipient: null
        };
        vm.sort = {
            field: 'executionDate',
            direction: 'desc'
        };
        vm.pagination = {
            page: 0,
            size: 50,
            hasMore: true,
            isLoadingMore: false
        };
        vm.histories = [];
        vm.stats = {
            errorCount: 0,
            areaCount: 0
        };
        vm.isRefreshing = false;
        vm.isInitialized = false;
        vm.agences = [];
        vm.rules = [];
        vm.availableRecipients = [];
        vm.canFilterRecipient = false;
        vm.canCreateTemporaryExclusion = false;
        vm.canUpdateProcessedStatus = false;

        vm.search = refreshList;
        vm.loadMore = loadMore;
        vm.onFiltersChanged = onFiltersChanged;
        vm.changeSort = changeSort;
        vm.isSortActive = isSortActive;
        vm.buildRuleLabel = buildRuleLabel;
        vm.openCreateTicket = openCreateTicket;
        vm.openCreateExclusion = openCreateExclusion;
        vm.applyAreaFilter = applyAreaFilter;
        vm.applyRuleFilter = applyRuleFilter;
        vm.applyErrorItemFilter = applyErrorItemFilter;
        vm.setViewMode = setViewMode;
        vm.toggleProcessed = toggleProcessed;
        vm.isUpdatingProcessed = isUpdatingProcessed;
        vm.hasProcessedFeedback = hasProcessedFeedback;
        vm.date = {
            startDate: new Date(),
            endDate: new Date()
        };

        vm.date.startDate.setDate(vm.date.startDate.getDate() - 7);

        Principal.identity().then(function(account) {
            currentAccount = account;
            var authorities = account && account.authorities ? account.authorities : [];
            var isAdmin = authorities.indexOf('ROLE_ADMIN') !== -1;
            var isSuperAdmin = authorities.indexOf('ROLE_SUPER_ADMIN') !== -1;
            var isAreaManager = authorities.indexOf('ROLE_AREA_MANAGEMENT') !== -1;

            vm.canCreateTemporaryExclusion = isAdmin;
            vm.canUpdateProcessedStatus = isAdmin || isSuperAdmin || isAreaManager;

            if (isAdmin || isSuperAdmin || isAreaManager) {
                vm.availableRecipients.push('AREA_MANAGER');
            }
            if (isAdmin || isSuperAdmin) {
                vm.availableRecipients.push('TOP_MANAGER');
            }
            vm.canFilterRecipient = vm.availableRecipients.length > 1;
        });

        Agence.query(function(result) {
            vm.agences = normalizeAreas(result || []);
            reconcileSelectedFilters();
        });
        MonitoringRule.query({ page: 0, size: 200, sort: 'id,asc' }, function(result) {
            vm.rules = normalizeRules(result || []);
            reconcileSelectedFilters();
        });

        $scope.$watch(function() {
            var start = vm.date && vm.date.startDate ? new Date(vm.date.startDate).getTime() : '';
            var end = vm.date && vm.date.endDate ? new Date(vm.date.endDate).getTime() : '';
            return start + '|' + end;
        }, function(newValue, oldValue) {
            if (!vm.isInitialized) {
                return;
            }
            if (newValue !== oldValue) {
                refreshList();
            }
        });

        angular.element($window).on('scroll', onWindowScroll);
        $scope.$on('$destroy', function() {
            destroyed = true;
            angular.forEach(processedUpdates, function(update) {
                if (update.timer) { $timeout.cancel(update.timer); }
            });
            angular.element($window).off('scroll', onWindowScroll);
        });

        vm.isInitialized = true;
        refreshList();

        $scope.openRangeDateTimePicker = function() {
            $('#daterange1').data('daterangepicker').toggle();
        };

        function refreshList() {
            listRevision++;
            angular.forEach(processedUpdates, function(update, uuid) {
                if (!update.pending) {
                    if (update.timer) { $timeout.cancel(update.timer); }
                    delete processedUpdates[uuid];
                }
            });
            vm.pagination.page = 0;
            vm.pagination.hasMore = true;
            vm.histories = [];
            fetchPage(true);
        }

        function loadMore() {
            if (!vm.pagination.hasMore || vm.pagination.isLoadingMore || vm.isRefreshing || hasActiveProcessedUpdates()) {
                return;
            }
            fetchPage(false);
        }

        function fetchPage(reset) {
            if (reset) {
                vm.isRefreshing = true;
            } else {
                vm.pagination.isLoadingMore = true;
            }

            var revision = listRevision;
            var pageToLoad = vm.pagination.page;
            MonitoringRuleErrorHistory.query(buildParams(pageToLoad), function(result) {
                if (destroyed || revision !== listRevision) { return; }
                var items = result || [];
                angular.forEach(items, applyProcessedUpdate);
                if (reset) {
                    vm.histories = items;
                } else {
                    // Replayed pages after a removal must not duplicate the rows already displayed.
                    var existingRows = {};
                    angular.forEach(vm.histories, function(history) { existingRows[history.rowKey] = true; });
                    angular.forEach(items, function(history) {
                        if (!existingRows[history.rowKey] && matchesProcessedFilter(history)) {
                            vm.histories.push(history);
                            existingRows[history.rowKey] = true;
                        }
                    });
                }

                vm.pagination.hasMore = items.length === vm.pagination.size;
                vm.pagination.page = pageToLoad + 1;
                vm.isRefreshing = false;
                vm.pagination.isLoadingMore = false;
                updateStats();
                reconcileSelectedFilters();
                $timeout(checkAutoLoadMore);
            }, function(error) {
                if (!destroyed && revision === listRevision) { onError(error); }
            });
        }

        function buildParams(page) {
            var params = {
                viewMode: vm.filters.viewMode,
                processedStatus: vm.filters.processedStatus || 'all',
                sortField: vm.sort.field,
                sortDirection: vm.sort.direction,
                page: page,
                size: vm.pagination.size,
                _t: new Date().getTime()
            };
            if (vm.date && vm.date.startDate) {
                params.fromDate = $filter('date')(new Date(vm.date.startDate), 'yyyy-MM-dd');
            }
            if (vm.date && vm.date.endDate) {
                params.toDate = $filter('date')(new Date(vm.date.endDate), 'yyyy-MM-dd');
            }
            if (vm.filters.areaId) {
                params.areaId = vm.filters.areaId;
            }
            if (vm.filters.monitoringRuleId) {
                params.monitoringRuleId = vm.filters.monitoringRuleId;
            }
            if (vm.filters.recipient) {
                params.recipient = vm.filters.recipient;
            }
            if (vm.filters.errorItemText && vm.filters.errorItemText.trim().length > 0) {
                params.errorItemText = vm.filters.errorItemText.trim();
            }
            return params;
        }

        function updateStats() {
            var areaIds = {};
            var errorCount = 0;

            angular.forEach(vm.histories, function(history) {
                if (history && history.errorValue) {
                    errorCount += history.errorValue;
                }
                if (history && history.areaId) {
                    areaIds[history.areaId] = true;
                } else if (history && history.areaName) {
                    areaIds[history.areaName] = true;
                }
            });

            vm.stats.errorCount = errorCount;
            vm.stats.areaCount = Object.keys(areaIds).length;
        }

        function buildRuleLabel(item) {
            if (!item || !item.typeRule) {
                return '';
            }
            return $filter('translate')('wamasysApp.monitoringRule.typeEnum.' + item.typeRule)
                .replace('X', item.param1)
                .replace('Y', item.nbDays);
        }

        function onFiltersChanged() {
            if (!vm.isInitialized) {
                return;
            }
            refreshList();
        }

        function changeSort(field) {
            if (vm.sort.field === field) {
                vm.sort.direction = vm.sort.direction === 'asc' ? 'desc' : 'asc';
            } else {
                vm.sort.field = field;
                vm.sort.direction = field === 'uuidExecution' ? 'asc' : 'desc';
            }
            refreshList();
        }

        function isSortActive(field, direction) {
            return vm.sort.field === field && vm.sort.direction === direction;
        }

        function applyAreaFilter(history) {
            if (!history || !history.areaId) {
                return;
            }
            ensureAreaOption(history);
            $timeout(function() {
                vm.filters.areaId = parseInt(history.areaId, 10);
                refreshList();
            });
        }

        function applyRuleFilter(history) {
            if (!history || !history.monitoringRuleId) {
                return;
            }
            ensureRuleOption(history);
            $timeout(function() {
                vm.filters.monitoringRuleId = parseInt(history.monitoringRuleId, 10);
                refreshList();
            });
        }

        function applyErrorItemFilter(history) {
            if (!history || !history.errorItems || vm.filters.viewMode !== 'detail') {
                return;
            }
            vm.filters.errorItemText = history.errorItems;
            refreshList();
        }

        function setViewMode(viewMode) {
            if (vm.filters.viewMode === viewMode) {
                return;
            }
            vm.filters.viewMode = viewMode;
            refreshList();
        }

        function toggleProcessed(history) {
            if (!history || !history.uuidExecution) {
                return;
            }
            if (!vm.canUpdateProcessedStatus) {
                AlertService.warning('wamasysApp.monitoringRule.history.processedStatusRolesOnly');
                return;
            }
            updateProcessedStatus(history.uuidExecution, !history.processed);
        }

        function isUpdatingProcessed(history) {
            var update = history && processedUpdates[history.uuidExecution];
            return !!(update && update.pending);
        }

        function hasProcessedFeedback(history) {
            var update = history && processedUpdates[history.uuidExecution];
            return !!(update && update.feedback);
        }

        function hasActiveProcessedUpdates() {
            return Object.keys(processedUpdates).some(function(uuid) {
                return processedUpdates[uuid].pending || processedUpdates[uuid].feedback;
            });
        }

        function matchesProcessedFilter(history) {
            return vm.filters.processedStatus === 'all'
                || (vm.filters.processedStatus === 'processed' && history.processed)
                || (vm.filters.processedStatus === 'unprocessed' && !history.processed);
        }

        function applyProcessedUpdate(history) {
            var update = processedUpdates[history.uuidExecution];
            if (update && !update.pending) {
                history.processed = update.processed;
                history.processedBy = update.processedBy;
                history.processedAt = update.processedAt;
            }
        }

        function updateProcessedStatus(uuid, processed) {
            var previous = processedUpdates[uuid];
            if (destroyed || (previous && (previous.pending || previous.feedback))) { return; }
            if (previous && previous.timer) { $timeout.cancel(previous.timer); }
            var update = { pending: true };
            processedUpdates[uuid] = update;
            MonitoringRuleErrorHistory.updateProcessed({
                uuidExecution: uuid,
                processed: processed,
                _t: new Date().getTime()
            }, function() {
                if (destroyed) { return; }
                // Change every detail row of the execution only once the server confirms success.
                update.pending = false;
                update.processed = processed;
                update.processedBy = processed && currentAccount ? currentAccount.login : null;
                update.processedAt = processed ? new Date() : null;
                update.feedback = true;
                angular.forEach(vm.histories, applyProcessedUpdate);
                update.timer = $timeout(function() {
                    update.feedback = false;
                    update.timer = null;
                    var removed = 0;
                    vm.histories = vm.histories.filter(function(history) {
                        var keep = history.uuidExecution !== uuid || matchesProcessedFilter(history);
                        if (!keep) { removed++; }
                        return keep;
                    });
                    if (removed) {
                        listRevision++;
                        vm.pagination.isLoadingMore = false;
                        // Deletions shift server page offsets: replay overlapping pages to avoid missing alerts.
                        vm.pagination.page = Math.max(0, vm.pagination.page - Math.ceil(removed / vm.pagination.size));
                        updateStats();
                    }
                    checkAutoLoadMore();
                }, 2000);
            }, function(error) {
                if (destroyed) { return; }
                if (previous) { processedUpdates[uuid] = previous; }
                else { delete processedUpdates[uuid]; }
                AlertService.error(error && error.data ? error.data.message : 'Erreur');
            });
        }

        function openCreateTicket(history) {
            $uibModal.open({
                templateUrl: 'app/business/monitoring-rule/monitoring-rule-history-createticket-dialog.html',
                controller: 'MonitoringRuleHistoryCreateTicketController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    entity: function() {
                        return angular.copy(history);
                    }
                }
            }).result.then(handleActionResult);
        }

        function openCreateExclusion(history) {
            if (!vm.canCreateTemporaryExclusion) {
                AlertService.warning('wamasysApp.monitoringRule.history.excludeTempAdminOnly');
                return;
            }
            $uibModal.open({
                templateUrl: 'app/business/monitoring-rule/monitoring-rule-exclusion-dialog.html',
                controller: 'MonitoringRuleExclusionDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    entity: function() {
                        var firstItem = null;
                        if (!history.firstRefContrat && !history.firstSerialNumber && history.errorItems) {
                            var items = history.errorItems.split(';').filter(function(item) {
                                return item && item.trim().length > 0;
                            });
                            if (items.length === 1) {
                                firstItem = items[0].trim();
                            }
                        }
                        return {
                            id: null,
                            monitoringRuleId: history.monitoringRuleId,
                            areaId: history.areaId,
                            areaName: history.areaName,
                            validiteMois: 1,
                            referenceContrat: history.firstRefContrat || firstItem,
                            serialNumber: history.firstSerialNumber || null,
                            commentaire: 'Exclusion temporaire créée depuis l\'historique'
                        };
                    },
                    historyContext: function() {
                        return {
                            uuidExecution: history.uuidExecution
                        };
                    }
                }
            }).result.then(handleActionResult);
        }

        function handleActionResult(result) {
            if (result && result.markAsProcessed && result.uuidExecution) {
                updateProcessedStatus(result.uuidExecution, true);
                return;
            }
            refreshList();
        }

        function ensureAreaOption(history) {
            if (!vm.agences || !history || !history.areaId) {
                return;
            }
            var normalizedId = parseInt(history.areaId, 10);
            var exists = false;
            angular.forEach(vm.agences, function(agence) {
                if (parseInt(agence.id, 10) === normalizedId) {
                    exists = true;
                }
            });
            if (!exists) {
                vm.agences.push({
                    id: normalizedId,
                    nom: history.areaName || ('Zone ' + normalizedId)
                });
            }
            vm.agences = normalizeAreas(vm.agences);
        }

        function ensureRuleOption(history) {
            if (!vm.rules || !history || !history.monitoringRuleId) {
                return;
            }
            var normalizedId = parseInt(history.monitoringRuleId, 10);
            var exists = false;
            angular.forEach(vm.rules, function(rule) {
                if (parseInt(rule.id, 10) === normalizedId) {
                    exists = true;
                }
            });
            if (!exists) {
                vm.rules.push({
                    id: normalizedId,
                    typeRule: history.typeRule,
                    param1: history.param1,
                    nbDays: history.nbDays
                });
            }
            vm.rules = normalizeRules(vm.rules);
        }

        function reconcileSelectedFilters() {
            if (vm.filters.areaId) {
                ensureAreaOption({
                    areaId: vm.filters.areaId,
                    areaName: findAreaName(vm.filters.areaId)
                });
                vm.filters.areaId = parseInt(vm.filters.areaId, 10);
            }
            if (vm.filters.monitoringRuleId) {
                ensureRuleOption(findRule(vm.filters.monitoringRuleId));
                vm.filters.monitoringRuleId = parseInt(vm.filters.monitoringRuleId, 10);
            }
        }

        function findAreaName(areaId) {
            var areaName = null;
            angular.forEach(vm.histories, function(history) {
                if (!areaName && history && parseInt(history.areaId, 10) === parseInt(areaId, 10)) {
                    areaName = history.areaName;
                }
            });
            return areaName || ('Zone ' + areaId);
        }

        function findRule(ruleId) {
            var foundRule = null;
            angular.forEach(vm.histories, function(history) {
                if (!foundRule && history && parseInt(history.monitoringRuleId, 10) === parseInt(ruleId, 10)) {
                    foundRule = {
                        monitoringRuleId: history.monitoringRuleId,
                        typeRule: history.typeRule,
                        param1: history.param1,
                        nbDays: history.nbDays
                    };
                }
            });
            return foundRule || {
                monitoringRuleId: ruleId
            };
        }

        function normalizeAreas(areas) {
            angular.forEach(areas, function(area) {
                if (area && area.id !== undefined && area.id !== null) {
                    area.id = parseInt(area.id, 10);
                }
            });
            return areas;
        }

        function normalizeRules(rules) {
            angular.forEach(rules, function(rule) {
                if (rule && rule.id !== undefined && rule.id !== null) {
                    rule.id = parseInt(rule.id, 10);
                }
            });
            return rules;
        }

        function onWindowScroll() {
            if (shouldLoadMore()) {
                $scope.$applyAsync(loadMore);
            }
        }

        function shouldLoadMore() {
            if (vm.isRefreshing || vm.pagination.isLoadingMore || !vm.pagination.hasMore || hasActiveProcessedUpdates()) {
                return false;
            }
            var scrollTop = $window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
            var windowHeight = $window.innerHeight || document.documentElement.clientHeight || 0;
            var documentHeight = Math.max(document.body.scrollHeight, document.documentElement.scrollHeight);
            return scrollTop + windowHeight + 200 >= documentHeight;
        }

        function checkAutoLoadMore() {
            if (shouldLoadMore()) {
                loadMore();
            }
        }

        function onError(error) {
            vm.isRefreshing = false;
            vm.pagination.isLoadingMore = false;
            AlertService.error(error && error.data ? error.data.message : 'Erreur');
        }
    }
})();
